<template>
	<div class="welcome">
		<div>
			<el-row :gutter="4">
				<el-col :span="10"></el-col>
				<el-col :span="7">
					<div style="font-size: 30px;color: white;">产品详情</div>
				</el-col>
				<el-col :span="7">
					<el-menu mode="horizontal">
						<el-sub-menu index="1">
							<template #title>
								<div style="font-size: 20px;border-bottom-color: transparent;">欢迎[{{ loginNickName }}]
								</div>
							</template>
							<el-menu-item @click="handleToPage('/')" index="home">首页</el-menu-item>
							<el-menu-item @click="handleToPage('/userInfo/UserInfoHome')"
								index="userInfo">个人中心</el-menu-item>
							<el-menu-item @click="logout()" index="logout">登出</el-menu-item>
						</el-sub-menu>
					</el-menu>
				</el-col>

			</el-row>
		</div>
		<div class="subjectBackground">
			<el-row>
				<el-col :span="4"></el-col>
				<el-col :span="16">
					<el-tabs v-model="productType">
						<el-tab-pane v-for="productInfo in productInfos" :name="productInfo.type" :key="productInfo.id">
							<template #label><span class="tab-label">{{productInfo.name}}</span></template>
							<div v-if="productInfo.type==='midFire'">
								<div style="font-size: 20px; color: white">鉴定站:
									<el-cascader v-model="finalAreaValue" :options="areaOptions"
										@change="(val) => { areaChange(val, productInfo.id)}" placeholder="请选择地区"
										ref="cascaderArea"></el-cascader>
									&nbsp;&nbsp;
									<el-link style="font-size: large;color: blue"
										@click="handleToPage('/fire/MediumFireDeviceHome')">>>免费试用</el-link>
								</div>
                <el-card v-for="extraInfo in areaExtraInfo" :key="extraInfo.id" style="margin-top: 10px">
                  <text>考试地点：{{extraInfo.description}}</text><br>
                  注意点：<text style="color: red">{{extraInfo.attention}}</text>
                </el-card>
								<el-row>
									<el-col :span="8" v-for="productDetailType in productDetailTypes"
										:key="productDetailType.type">
										<el-card shadow="hover" style="margin-top: 10px;margin-right: 10px;">
											<template #header>
												<div style="font-size: 20px;text-align:center;">
													{{productDetailType.name}}
												</div>
											</template>
											<div v-for="productDetailInfo in productDetailInfos"
												:key="productDetailInfo.id">
												<el-button
													v-if="productDetailInfo.type===productDetailType.type && (productDetailInfo.money/100)<=100"
													type="success" size="large"
													style="width: 250px; margin-bottom: 20px" round
													@click="buyProduct(productDetailInfo,productInfo,productDetailType)">
													￥{{productDetailInfo.money/100}} 购买{{productDetailInfo.periodName}}
												</el-button>
												<el-button
													v-if="productDetailInfo.type===productDetailType.type && 100<(productDetailInfo.money/100) &&(productDetailInfo.money/100)<=300"
													type="primary" size="large"
													style="width: 250px;  margin-bottom: 20px" round
													@click="buyProduct(productDetailInfo,productInfo,productDetailType)">
													￥{{productDetailInfo.money/100}} 购买{{productDetailInfo.periodName}}
												</el-button>
												<el-button
													v-if="productDetailInfo.type===productDetailType.type && (productDetailInfo.money/100)>300"
													type="warning" size="large"
													style="width: 250px;  margin-bottom: 20px" round
													@click="buyProduct(productDetailInfo,productInfo,productDetailType)">
													￥{{productDetailInfo.money/100}} 购买{{productDetailInfo.periodName}}
												</el-button>
											</div>
										</el-card>
									</el-col>
								</el-row>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-col>
			</el-row>
		</div>
	</div>

	<el-dialog v-model="showWeChatDialog" append-to-body style="width: 800px;">
		<el-row>
			<el-col :span="8">
				<div>
					<span>使用微信扫一扫即可完成支付</span><br>
					<img :src="QRCodeImage" style="height: 200px;width: 200px;" alt="QRCODE" /><br>
					费用￥<span style="color: red;">{{productDetailInfo.money/100}}</span>元<br>
					请在30分钟内完成付款
				</div>

			</el-col>
			<el-col :span="16">
				<div>
					已选购<span style="color: blue;">{{finalAreaLabel}} {{productInfo.name}} {{productDetailType.name}}
						{{productDetailInfo.periodName}}</span>
					<br>费用￥<span style="color: red;">{{productDetailInfo.money/100}}</span>元<br><br>
					<div style="font-size: 14px">注意:<br>
						不限制设备个数，但同一时间只能有一台设备在线学习,切换设备需重新登录。<br>
						此为虚拟物品,发货后不退不换，请试用后再购买。<br>
						请核查确认购买的鉴定站：<span style="color: red;">{{finalAreaLabel}}</span>是否正确,<span
							style="color: orangered;">购买后无法更改鉴定站</span><br>
						<span>多次购买，账户有效期将依次顺延</span><br>
						<span>支付完成后，享受如下权益：</span><br>
						<span>1.账号可立即使用。</span><br>
						<span>2.进入购买鉴定站的微信群，寻找到志同道合的考友。</span><br>
						<span>3.若有疑问可进入微信群联系管理员咨询</span><br>
					</div>
				</div>
			</el-col>
		</el-row>

		<span class="dialog-footer">
			<el-button @click="cancelPay" style="float:right;margin-right: 20px">取消支付</el-button>
			<el-button type="primary" @click="submitPay" style="float:right;margin-right: 20px">已完成支付</el-button>
		</span>
	</el-dialog>

	<el-dialog v-model="showCancelPayDialog" append-to-body style="width: 600px;">
		<div>
			也可在淘宝页面购买，<br>
			购买后在个人中心->我的订单 页面进行核销<br>
		</div>
		<span class="dialog-footer">
			<el-button type="primary" @click="goTaobao" style="float:right;margin-right: 20px">去淘宝选购</el-button>
			<el-button @click="cancelAll" style="float:right;margin-right: 20px">取消</el-button>
		</span>
	</el-dialog>

	<el-dialog v-model="showSubmitPayDialog" append-to-body style="width: 400px;">
		<div>
			感谢您的信任，您的权益正在生成，<br>
			请用微信扫一扫加入微信群，<br>
			可与志同道合的考友一起学习进步,<br>
			若有问题也可在群里直接联系到管理员。<br>
			<img :src="`/view${productDetailInfo.groupImagePath}`" style="width:300px;height: auto" alt="groupImage" />
		</div>
		<span class="dialog-footer">
			<el-button type="primary" @click="hasJoin" style="float:right;margin-right: 20px">已加入微信群</el-button>
		</span>
	</el-dialog>

</template>

<script>
	import router from "@/router";
	import request from "@/utils/request";
	import {
		ElMessage
	} from "element-plus";
	import {
		computed,
		ref
	} from "vue";

	const loginNickName = localStorage.getItem("loginNickName");

	const loginUserId = localStorage.getItem("loginUserId");
	const isBuy = ref(false);
	const productDetailInfos = ref([]);
	const productInfos = ref([]);
	const theoryDetailInfos = ref([]);
	const productType = ref('midFire');
	const QRCodeImage = ref('');
  const areaExtraInfo= ref(null);

	async function getProductByStatus() {
		await request.get('/productInfo/', {
				params: {
					status: 'active'
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					productInfos.value = result.data;
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("getProductByAreaId error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

  async function getExtraInfo(areaId){
    await request.get('/extraRelationInfo/type', {
      params: {
        relationId: areaId,
        type:"areaId",
      }
    })
        .then(response => {
          const result = response.data; // 将接口返回的数据赋值给result
          areaExtraInfo.value=result.data;
        })
        .catch(error => {
          console.log("getExtraInfo error:" + error);
          // ElMessage.error("系统异常，请联系管理员");
        });
  }

	async function getProductDetailType(areaId, productId) {
		await request.get('/productDetail/type', {
				params: {
					areaId: areaId,
					userId: loginUserId,
					productId: productId,
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					productDetailTypes.value = result.data;
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("getProductDetailType error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function getProductDetailByAreaId(areaId, productId) {
		await request.get('/productDetail/areaId', {
				params: {
					areaId: areaId,
					userId: loginUserId,
					productId: productId,
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					productDetailInfos.value = result.data;
					theoryDetailInfos.value = computed(() => {
						return productDetailInfos.value.filter((item) =>
							item.type.includes("midFireAll")
						);
					});
				} else {
					ElMessage.warning(result.msg);
					// router.push("/login");
				}
			})
			.catch(error => {
				console.log("getProductByAreaId error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function getAreaAll() {
		await request.get('/area/all',{
      params: {type: "fire"
      }
    }).then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					areaOptions.value = result.data;
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("getAreaAll error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getUserAuthorization(type) {
		request.get('/userAuthorization/get', {
				params: {
					userId: loginUserId,
					type: type
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					isBuy.value = result.data.length > 0;
					if (isBuy.value) {
						buyAreaOptions.value = Array.from(result.data.reduce((map, item) => {
							const key = item.areaId;
							if (!map.has(key)) {
								map.set(key, {
									"id": item.areaId,
									"name": item.areaName
								});
							}
							return map;
						}, new Map()).values());
						this.buyAreaValue = buyAreaOptions.value[0].id;
					}
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getCascaderObj(val, opt) {
		return val.map(function(value) {
			for (var itm of opt) {
				if (itm.value === value) {
					opt = itm.children;
					return itm;
				}
			}
			return null;
		});
	}

	async function getPayQRCode(money, productDetailId) {
		await request.get('/weChatPay/payCode', {
				params: {
					userId: loginUserId,
					money: money,
					productDetailId: productDetailId
				}
			})
			.then(response => {
				QRCodeImage.value = response.data;
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}
	const areaOptions = ref([]);
	const buyAreaOptions = ref([]);
	const finalAreaValue = ref('');
	const finalAreaLabel = ref('');
	const productDetailTypes = ref([]);
	const productInfo = ref('');
	const productDetailInfo = ref('');
	const showWeChatDialog = ref(false);
	const productDetailType = ref('');
	const showCancelPayDialog = ref(false);
	const showSubmitPayDialog = ref(false);

	export default {
		name: "BuyPage",
		async created() {
			await getAreaAll()
			await getProductByStatus.call(this);
			if (loginUserId !== null && loginUserId !== '') {
				getUserAuthorization.call(this, "subject");
			}

		},
		data() {
			return {
				loginNickName: loginNickName,
				isBuy: isBuy,
				// areaValue: [], // 下拉框选中的值
				areaOptions: areaOptions,
				studyType: 'practice',
				buyAreaValue: '',
				buyAreaOptions: buyAreaOptions,
				finalAreaValue: finalAreaValue,
				productInfos: productInfos,
				productType: productType,
				productDetailInfos: productDetailInfos,
				productDetailTypes: productDetailTypes,
				finalAreaLabel: finalAreaLabel,
				productDetailInfo: productDetailInfo,
				productInfo: productInfo,
				showWeChatDialog: showWeChatDialog,
				productDetailType: productDetailType,
				QRCodeImage: QRCodeImage,
				showCancelPayDialog: showCancelPayDialog,
				showSubmitPayDialog: showSubmitPayDialog,
        areaExtraInfo:areaExtraInfo,
			}
		},
		methods: {
			handleToPage(path) {
				router.push(path);
			},
			handleToChoosePage(trainPath, examPath, buyMode, subjectType) {
				if (!isBuy.value && finalAreaValue.value === "") {
					this.$message.error("请选择鉴定站");
					return;
				}

				if (isBuy.value) {
					finalAreaValue.value = this.buyAreaValue;
				}
				if (this.studyType === 'practice') { //训练模式
					router.push({
						path: trainPath,
						query: {
							areaId: finalAreaValue.value,
							studyMode: this.studyType,
							buyMode: buyMode,
							subjectType: subjectType
						}
					});
				} else {
					router.push({
						path: examPath,
						query: {
							areaId: finalAreaValue.value,
							studyMode: this.studyType,
							buyMode: buyMode,
							subjectType: subjectType
						}
					});
				}
			},
			logout() {
				if (localStorage.getItem('loginNickName')) {
					localStorage.removeItem('loginNickName');
				}
				if (localStorage.getItem('userToken')) {
					localStorage.removeItem('userToken')
				}
				if (localStorage.getItem('loginUserName')) {
					localStorage.removeItem('loginUserName')
				}
				if (localStorage.getItem('loginUserId')) {
					localStorage.removeItem('loginUserId')
				}
				this.$message.warning("登出成功");
				router.push({
					path: "/"
				});
			},
			async areaChange(value, productId) {
				if (value && value.length) {
					finalAreaValue.value = value[value.length - 1];
					finalAreaLabel.value = getCascaderObj(value, this.areaOptions)[1].label;
          await getExtraInfo.call(this,finalAreaValue.value);
					await getProductDetailType.call(this, finalAreaValue.value, productId);
					await getProductDetailByAreaId.call(this, finalAreaValue.value, productId)
				}
			},
			async buyProduct(productDetailInfo, productInfo, productDetailType) {
				this.productDetailInfo = productDetailInfo;
				this.productDetailType = productDetailType;
				this.productInfo = productInfo;
				await getPayQRCode.call(this, productDetailInfo.money, productDetailInfo.id);

				showWeChatDialog.value = true;
			},
			cancelPay() {
				showWeChatDialog.value = false;
				showCancelPayDialog.value = true;
				showSubmitPayDialog.value = false;

			},
			submitPay() {
				showWeChatDialog.value = false;
				showCancelPayDialog.value = false;
				showSubmitPayDialog.value = true;
			},

			goTaobao() {
				window.open(productDetailInfo.value.buyUrl);
				ElMessage.success("请在淘宝页面购买后，获取到核销码，再在个人中心->核销页面进行核查");
				this.cancelAll();
			},

			cancelAll() {
				showWeChatDialog.value = false;
				showCancelPayDialog.value = false;
				showSubmitPayDialog.value = false;
			},
			hasJoin() {
				this.cancelAll();
				router.push({
					path: "/userInfo/userInfoHome"
				});
			}
		}
	}
</script>


<style scoped>
	.mode-col {
		height: 320px;
		width: 220px;
		/* 设置一个高度让背景显示出来 */
		background-size: contain;
		background-repeat: no-repeat;
		/* 背景图片覆盖整个元素 */
		transition: background-image 0.5s;
		/* 可选的，背景图变化过渡效果 */
		align-content: center;
		/*background-color: lightgray;*/
	}

	.welcome {
		/*background-image: url("../../assets/picture/FireEngine/fireHeader.png");*/
		background-color: blue;
	}

	.subjectBackground {
		background-image: url("@/assets/picture/FireEngine/subjectBackground.jpg");
		/*background-size: 120%;*/
		background-repeat: no-repeat;
		background-position: center;
		height: 700px;

	}

	/* 修改单选按钮内文字的颜色 */
	.custom-radio-group :deep(.el-radio__input) {
		/* ... */
		width: 20px;
		/* 修改单选按钮的宽度 */
		height: 20px;
		/* 修改单选按钮的高度 */
	}

	.custom-radio-group :deep(.el-radio__label) {
		font-size: 20px;
		/* 修改字体大小 */
		color: white;
		/* 修改字体颜色 */
	}

	/*!* 如果需要深度选择 *!*/
	/*::v-deep .el-sub-menu__title {*/
	/*  color: black;*/
	/*  font-size:18px ;*/
	/*}*/

	.el-menu {
		background-color: transparent;
		border-bottom-color: transparent;
	}

	/*.el-sub-menu{*/
	/*  !*background-color: blue !important;*!*/
	/*  !*color: blue !important;*!*/
	/*  !*width: 200px;*!*/
	/*  !*font-size: 18px;*!*/
	/*  !*text-align: center !important;*!*/
	/*}*/
	/*.el-sub-menu .el-sub-menu__title {*/
	/*  display: flex;*/
	/*  align-items: center !important;*/
	/*  justify-content: center !important;*/
	/*}*/

	.el-menu-item {
		background-color: transparent !important;
		color: black !important;
		font-weight: 50;
		width: 200px;
		font-size: 18px;
		text-align: center;

		&:not(.is-disabled):hover {
			color: gray !important;
			background-color: lightgray !important;
			width: 200px;
			text-align: center;
		}
	}

	.el-cascader-panel {
		font-size: 16px !important;
	}

	.tab-label {
		font-size: 20px;
	}
</style>
